import {loadScript} from '../utils';

import * as events from './events';

export {events};

const SCRIPT_ELEMENT_CLASS = 'RTA2-loader';

const DIRECT_EVENTS = [events.PAGE_VIEW_EVENT, events.TAB_VIEW_EVENT];
const GENERIC_EVENT_NAME = 'page_event';

interface Metadata {
  [key: string]: string | string[] | number | undefined;
}

interface RTAWindow extends Window {
  // tslint:disable no-any
  RTA?: {
    tedEvent: (
      eventName: string,
      metadata?: {action: string; name: string; value: Metadata | string} | Metadata
    ) => void;
  };
}

interface QueuedEvent {
  eventName: string;
  metadata?: Metadata;
}

let eventQueue: QueuedEvent[] = [];

export const clearEventQueue = () => {
  eventQueue = [];
};

const buildInternalReferrer = (key: string) =>
  [window.location.protocol, '/' + window.location.host, 'click', key].join('/');

const sendEventToRTA = (eventName: string, metadata?: Metadata) => {
  const RTA = (window as RTAWindow).RTA;

  if (!RTA || !RTA.tedEvent) {
    throw new Error('RTA not loaded');
  }

  if (DIRECT_EVENTS.includes(eventName)) {
    if (eventName === events.PAGE_VIEW_EVENT) {
      if (metadata) {
        metadata.referrer = buildInternalReferrer((metadata.topStoriesKey as string) || 'search');

        if (metadata.query && typeof metadata.query === 'string') {
          metadata.referrer += '?q=' + encodeURIComponent(metadata.query);
          metadata.tags = metadata.query.trim().split(/\s+/);
        }
      } else {
        // tslint:disable-next-line: no-console
        console.warn('Cannot track click to unknown destination');

        return;
      }
    } else if (eventName === events.TAB_VIEW_EVENT) {
      if (metadata && metadata.previousTabKey && metadata.previousTabKey !== metadata.channel) {
        metadata.referrer = buildInternalReferrer(metadata.previousTabKey as string);
      }
      if (metadata && metadata.query && typeof metadata.query === 'string') {
        metadata.tags = metadata.query.trim().split(/\s+/);
      }
    }
    RTA.tedEvent(eventName, metadata);
  } else {
    RTA.tedEvent(GENERIC_EVENT_NAME, {
      action: 'store',
      name: eventName,
      value: metadata || 'event'
    });
  }
};

export const trackEvent = (eventName: string, metadata?: Metadata) => {
  const RTA = (window as RTAWindow).RTA;

  if (RTA && RTA.tedEvent) {
    sendEventToRTA(eventName, metadata);
  } else {
    eventQueue.push({eventName, metadata});
  }
};

export const initTracking = async ({hosts, script}: {hosts: string; script: string}) => {
  try {
    await loadScript(script, {
      class: SCRIPT_ELEMENT_CLASS,
      'data-hosts': hosts
    });

    const RTA = (window as RTAWindow).RTA;

    if (!RTA || !RTA.tedEvent) {
      throw new Error('Error loading RTA');
    }

    for (const queuedEvent of eventQueue) {
      sendEventToRTA(queuedEvent.eventName, queuedEvent.metadata);
    }

    clearEventQueue();
  } catch (error) {
    // TODO: log error
  }
};
